import { render, staticRenderFns } from "./payman-info.vue?vue&type=template&id=04d5187c&"
import script from "./payman-info.vue?vue&type=script&lang=js&"
export * from "./payman-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports